import { NEW_BASE_URL } from "../Constant";
import { newReconGetServiceAPI, newReconServiceAPI } from "./APIutils";

export function fetchAllCityOperators({
  cityId,
  pageNo,
  pageSize,
}) {
  const url = `${NEW_BASE_URL}/v1/adminPage/getOpWiseSettlementConfig?cityId=${cityId}&pageNo=${pageNo}&pageSize=${pageSize}`;
  return newReconGetServiceAPI(url);
}

export function setSettlementCycleService({
  cityId,
  operatorIdArr,
  cycleType,
}) {
  const url = `${NEW_BASE_URL}/v1/adminPage/updateOpWiseSettlementConfig`;
  return newReconServiceAPI(url, {
    cityId,
    operatorIdArr,
    cycleType,
  });
}
